import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { TimelineLabelType } from "../../../constants/ComponentTypes";
import { format } from "date-fns";
import { Link } from "react-router-dom";

const styles = () => ({
  root: {
    fontSize: "14px",
    color: "#5A5B62",
    marginTop: "4px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },

  link: {
    color: "inherit",
    textDecoration: "underline",
  },
});

class Description extends React.Component {
  render() {
    const { classes, status } = this.props;

    if (status.desc === null) {
      return null;
    }

    const regexp = /注文番号([0-9]+)の追跡番号（([0-9]+)）が「(.*)」になりました/g;

    const res =
      status.desc && status.desc.matchAll
        ? [...status.desc.matchAll(regexp)]
        : [];
    const matches = [...res];

    if (matches && matches.length) {
      const matchFirstIndex = 0;
      const matchThirdIndex = 2;
      const matchFourthIndex = 3;
      const addressModel = status.letter_order_address || status.follow_call_order_address;
      const orderModel = addressModel.letter_order || addressModel.follow_call_order;

      return (
        <div className={classes.root} title={status.desc}>
          注文番号
          <Link to={`/orders/${orderModel.order.id}`} className={classes.link}>
            {orderModel.order.id}
          </Link>
          追跡番号
          <a
            href={`https://trackings.post.japanpost.jp/services/srv/search/?requestNo1=${matches[matchFirstIndex][matchThirdIndex]}&search.x=0&search.y=0&startingUrlPatten=&locale=ja`}
            target="_blank"
            className={classes.link}
          >
            {matches[matchFirstIndex][matchThirdIndex]}
          </a>
          が「{matches[matchFirstIndex][matchFourthIndex]}」になりました
        </div>
      );
    } else {
      return (
        <div
          className={classes.root}
          title={status.desc}
          style={{
            display:
              status.status_label_type === TimelineLabelType.ORDER_SHIPPED.value
                ? "none"
                : "block",
          }}
        >
          {status.desc}
          {/* 商談獲得の場合で商談日時があれば商談日時を表示 */}
          {TimelineLabelType.APPOINTMENT.value === status.status_label_type &&
            status.scheduled_at ? (
            <span>
              （商談日時：
              {format(new Date(status.scheduled_at), "yyyy年MM月dd日 HH:mm")}）
            </span>
          ) : null}
        </div>
      );
    }
  }
}

Description.propTypes = {
  classes: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
};

export default withStyles(styles)(Description);



// WEBPACK FOOTER //
// ./src/components/Timeline/parts/Description.jsx